import mapBoundariesReducer from './reducers';

export default mapBoundariesReducer;
